"use strict";

var _toConsumableArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _table = require("@bento-core/table");
var _TableService = require("./TableService");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
/**
* Updates table row when table state is changed 1. (paginated action) and 2. filter action
*/
var TableController = function TableController(props) {
  var tblRows = props.tblRows,
    table = props.table;
  if (!tblRows) {
    return /*#__PURE__*/_react.default.createElement(_core.Container, {
      maxWidth: "xl"
    }, /*#__PURE__*/_react.default.createElement(_core.CircularProgress, null));
  }
  /**
  * update rows
  * set selected rows isChecked to TRUE
  */
  var updateRows = (0, _TableService.setSelectedRows)(tblRows, table);
  var _table$page = table.page,
    page = _table$page === void 0 ? 0 : _table$page,
    _table$rowsPerPage = table.rowsPerPage,
    rowsPerPage = _table$rowsPerPage === void 0 ? 10 : _table$rowsPerPage,
    sortBy = table.sortBy,
    sortOrder = table.sortOrder;
  /**
  * client table aplhanumeric sorting for column table
  * uses string prototype function for sorting
  */
  var alphaNumericSort = function alphaNumericSort(a, b) {
    return "".concat(a[sortBy]).localeCompare("".concat(b[sortBy]), undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  };
  /**
  * sort base on table state
  */
  var sortRows = function sortRows(a, b) {
    if (sortOrder === 'asc') {
      return alphaNumericSort(a, b);
    }
    return alphaNumericSort(b, a);
  };
  var sortedRows = _toConsumableArray(updateRows).sort(function (a, b) {
    return sortRows(a, b);
  });
  var startIndex = page * rowsPerPage;
  var endIndex = startIndex + rowsPerPage;
  var displayRows = _toConsumableArray(sortedRows).slice(startIndex, endIndex);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_table.TableView, _extends({}, props, {
    tableRows: displayRows
  })));
};
var _default = TableController;
exports.default = _default;